module.exports = __webpack_public_path__ + "static/media/loja.b2d1cfee.svg";